import React from 'react';
import Typography from '@mui/material/Typography';

import translate from '@localise/translate';

import SectionWrap from '@layout/SectionWrap';

import styles from './style.scss';

const AboutUs = (): JSX.Element => {
  const align = 'center';

  return (
    <SectionWrap>
      <Typography variant="h2" textAlign={align}>
        {translate('aboutUs.title')}
      </Typography>
      <div className={styles.content}>
        <div>
          <Typography variant="h6" fontWeight={600} sx={{ whiteSpace: 'pre-wrap' }} textAlign={align}>
            {translate('aboutUs.subTitle')}
          </Typography>
          <Typography variant="body1" mt={2} sx={{ whiteSpace: 'pre-wrap' }} textAlign={align}>
            {translate('aboutUs.description')}
          </Typography>
        </div>
      </div>
    </SectionWrap>
  );
};

export default AboutUs;
